<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <div class="box-header"></div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="行业管理" name="0">
              <tag :active-name="activeName" :list="industryList" @addIndustry="addIndustry" @delIndustry="delIndustry" ref="industryInput"></tag>
            </el-tab-pane>
            <el-tab-pane label="内容类别管理" name="1">
              <tag :active-name="activeName" :list="domainList" @addDomain="addDomain" @delDomain="delDomain" ref="domainInput"></tag>
            </el-tab-pane>
          </el-tabs>
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import Tag from '../../widgets/widgetTag'
import axios from 'axios'
export default {
  components: {
    Tag
  },
  data () {
    return {
      loading: false,
      inputValue: '',
      activeName: '0',
      currentPage: {
        one: 0
      },
      industryList: [],
      domainList: []
    }
  },
  methods: {
    // tab切换
    handleClick (tab, event) {
      console.log(this.activeName)
    },
    // 获取行业标签列表
    async getIndustryList () {
      let url = this.$config.API.tags.industry.list
      let params = {
        keys: '',
        page: 1
      }
      axios.post(url, params).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          this.industryList = res.data.industryList
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取内容标签列表
    async getDomainList () {
      let url = this.$config.API.tags.domain.list
      let params = {
        keys: '',
        page: 1
      }
      axios.post(url, params).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          this.domainList = res.data.industryList
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 添加标签
    addDomain (val) {
      let url = this.$config.API.tags.domain.add
      let params = {
        TITLE: val,
        demain_id: ''
      }
      axios.post(url, params).then(res => {
        if (res.status === 200 && res.data.result) {
          this.domainList.push(res.data.transmitObj)
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$refs.domainInput.inputValue = ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    addIndustry (val) {
      let url = this.$config.API.tags.industry.add
      let params = {
        TITLE: val,
        industry_id: ''
      }
      axios.post(url, params).then(res => {
        console.log(res)
        if (res.status === 200 && res.data.result) {
          this.industryList.push(res.data.transmitObj)
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$refs.industryInput.inputValue = ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 删除标签
    delIndustry (id) {
      let url = this.$config.API.tags.industry.delete
      let params = {
        industry_id: id
      }
      this.$confirm('要删除该标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(url, params).then(res => {
          if (res.status === 200 && res.data.result === 'success') {
            this.industryList = this.industryList.filter(item => {
              return item.ID !== id
            })
            this.$message({
              type: 'info',
              message: '已删除'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delDomain (id) {
      let url = this.$config.API.tags.domain.delete
      let params = {
        demain_id: id
      }
      this.$confirm('要删除该标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(url, params).then(res => {
          if (res.status === 200 && res.data.result === 'success') {
            this.domainList = this.domainList.filter(item => {
              return item.ID !== id
            })
            this.$message({
              type: 'info',
              message: '已删除'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  mounted () {
    this.getIndustryList()
    this.getDomainList()
  }
}
</script>

<style lang="scss">
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  #title{
    font-size: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// industry.vue?470826be